import React from 'react';
import { Defs, Mask, Path, Rect, Svg } from 'react-native-svg';
import { useUnistyles } from 'react-native-unistyles';

const STAR_PATH =
  'M12 2L15.09 8.26L22 9.27L17 14.14L18.18 21.02L12 17.77L5.82 21.02L7 14.14L2 9.27L8.91 8.26L12 2Z';
const STAR_X_POSITIONS = [15.5, 41.5, 67.5, 93.5, 119.5];
const STAR_Y = 15;
const STAR_SCALE = 0.8333;

export const ReviewStarsBubbleIcon: React.FC = () => {
  const { theme } = useUnistyles();
  return (
    <Svg width={155} height={57} viewBox="0 0 155 57" fill="none">
      <Defs>
        <Mask
          id="review-bubble-mask"
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="155"
          height="57"
        >
          <Rect fill="white" width="155" height="57" />
          <Path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M8 2C4.68629 2 2 4.68629 2 8V42C2 45.3137 4.68629 48 8 48H71.0669L77.5002 54L83.9335 48H147C150.314 48 153 45.3137 153 42V8C153 4.68629 150.314 2 147 2H8Z"
          />
        </Mask>
      </Defs>
      <Path
        d="M71.0669 48L72.431 46.5374L71.8548 46H71.0669V48ZM77.5002 54L76.1361 55.4626L77.5002 56.7348L78.8643 55.4626L77.5002 54ZM83.9335 48V46H83.1456L82.5694 46.5374L83.9335 48ZM4 8C4 5.79086 5.79086 4 8 4V0C3.58172 0 0 3.58172 0 8H4ZM4 42V8H0V42H4ZM8 46C5.79086 46 4 44.2091 4 42H0C0 46.4183 3.58172 50 8 50V46ZM71.0669 46H8V50H71.0669V46ZM78.8643 52.5374L72.431 46.5374L69.7028 49.4626L76.1361 55.4626L78.8643 52.5374ZM82.5694 46.5374L76.1361 52.5374L78.8643 55.4626L85.2976 49.4626L82.5694 46.5374ZM147 46H83.9335V50H147V46ZM151 42C151 44.2091 149.209 46 147 46V50C151.418 50 155 46.4183 155 42H151ZM151 8V42H155V8H151ZM147 4C149.209 4 151 5.79086 151 8H155C155 3.58172 151.418 0 147 0V4ZM8 4H147V0H8V4Z"
        fill="#DDDDDD"
        mask="url(#review-bubble-mask)"
      />
      {STAR_X_POSITIONS.map((x, i) => (
        <Path
          key={i}
          d={STAR_PATH}
          fill={theme.iconPrimary}
          transform={`translate(${x}, ${STAR_Y}) scale(${STAR_SCALE})`}
        />
      ))}
    </Svg>
  );
};

ReviewStarsBubbleIcon.displayName = 'ReviewStarsBubbleIcon';
